module.exports = __webpack_public_path__ + "static/media/banner_arrow-right.f24dca48.svg";